import styled from "styled-components";
import Button from "react-bootstrap/Button";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "../../i18n/TranslationProvider";

export const FilledSubmitButton = styled(Button)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const OutlineSubmitButton = ({
  disabled,
  onClick,
  children,
  type,
  style,
  className,
  centered,
  color,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`${centered ? " justify-content-center" : ""}`}>
      <FilledSubmitButton
        className={className ? className : "submitButton"}
        onClick={onClick}
        type={type || "button"}
        variant={`outline-${color ? color : "primary"}`}
        disabled={disabled}
        style={style}
      >
        {disabled ? (
          <>
            <Spinner
              aria-hidden="true"
              size="sm"
              as="span"
              animation="border"
              role="status"
            />
            {t("button2.saving")}
          </>
        ) : (
          children
        )}
      </FilledSubmitButton>
    </div>
  );
};

export default OutlineSubmitButton;